// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"088e186f","255":"8b757b27"}[chunkId] + ".chunk.css";
};